import axios from "axios";
export const API = "/api";
const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => { const token=localStorage.getItem("bnb_admin_token"); if(token) config.headers.Authorization=`Bearer ${token}`; return config; });
export default api;
